<template>
  <div
      v-if="isOpen"
      class="modal fade show"
      aria-labelledby="addNewCardTitle"
      style="display: block; background: #1c1d1c33"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div
                class="d-flex justify-content-between px-1 my-1 align-item-center">
              <h1 class="mb-0">{{ modalTitle }}</h1>
              <button
                  @click="toggleModal"
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
        <hr class="mt-0"/>

        <div class="pb-2">
          <!-- form -->
          <vForm @submit="submit">
            <div class="row gy-2 px-2">
              <div class="col-12">
                <label class="form-label" for="team_member_id">Team Member</label>
                <div>
                  <AsyncSelect
                      placeholder="Select Team Member"
                      v-model="selectedMember"
                      :api-service="fetchParties"
                      label="name"
                      :format-label="formatMemberLabel"
                      @update:modelValue="onSelectMember"
                  />
                  <ErrorMessage
                      name="member_id"
                      class="invalid-feedback d-block qcont"
                  />
                </div>
              </div>

              <div class="col-12">
                <label class="form-label" for="team_role">Team Role</label>
                <div>
                  <v-select
                      placeholder="Select Team Member"
                      v-model="memberForm.team_role_id"
                      :options="roles"
                      label="label"
                      :reduce="name => name.id"
                  />
                  <ErrorMessage
                      name="member_id"
                      class="invalid-feedback d-block qcont"
                  />
                </div>
              </div>

              <div class="col-12">
                <label class="form-label" for="designation">Designation</label>
                <div class="input-group">
                  <vField
                      type="text"
                      name="designation"
                      :value="memberForm.designation"
                      class="form-control add-credit-card-mask"
                      placeholder="Designation"
                      disabled
                  />
                  <ErrorMessage
                      name="code"
                      class="invalid-feedback d-block qcont"
                  />
                </div>
              </div>

              <div v-if="estTimeEnable" class="col-12">
                <label class="form-label" for="estimated_time">Est. Time (Hours)</label>
                <div class="input-group">
                  <vField
                      type="text"
                      name="estimated_time"
                      v-model="memberForm.estimated_time"
                      class="form-control"
                      placeholder="Est. Time (Hours)"
                  />
                  <ErrorMessage
                      name="estimated_time"
                      class="invalid-feedback d-block qcont"
                  />
                </div>
              </div>
            </div>

            <div class="col-12 text-center">
              <hr class="mt-2"/>
              <button
                  :disabled="loading"
                  type="submit"
                  class="btn btn-primary me-1 mt-1 waves-effect waves-float waves-light"
              >
                <div
                    v-if="loading"
                    class="spinner-border spinner-border-sm text-light"
                    role="status"
                >
                  <span class="visually-hidden">Loading...</span>
                </div>
                Submit
              </button>
              <button
                  @click.prevent="toggleModal"
                  class="btn btn-outline-secondary mt-1 waves-effect"
              >
                Cancel
              </button>
            </div>
          </vForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import handleProjects from "@/services/modules/procurement/project";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";

export default {
  name: "TeamMemberModal",

  components: {
    AsyncSelect
  },

  props: {
    modalTitle: {
      type: String,
      default: 'Add Team Member'
    },
    estTimeEnable: {
      type: Boolean,
      default: false
    },
    extraQuery: {
      type: String,
      default: ''
    },
    roles: {
      type: Array,
      default: () => []
    },
  },

  data() {
    return {
      loading: false,
      isOpen: false,
      selectedMember: null,
      memberForm: {
        team_member_id: null,
        team_member_name: null,
        team_role_id: null,
        team_role_label: null,
        designation: null,
        estimated_time: null,
      },
      members: [],
    };
  },

  watch: {
    'memberForm.team_role_id': function (newData) {
      const role = this.roles.find(function(el) { return el.id == newData; });
      if (role) {
          this.memberForm.team_role_label = role.label;
      }
    },
  },

  methods: {
    submit() {
      this.$emit("onSubmitForm", {...this.memberForm});
      this.toggleModal();
    },

    resetForm() {
      this.selectedMember = null;
      this.memberForm = {
        team_member_id: null,
        team_member_name: null,
        team_role_id: null,
        team_role_label: null,
        designation: null,
        estimated_time: null,
      };
    },

    toggleModal() {
      if (this.isOpen) {
        this.isOpen = false;
        this.resetForm();
        this.$emit('onCloseTeamMemberModal');
        return;
      }
      this.isOpen = true;
      this.resetForm();
    },

    formatMemberLabel(item) {
        let name = item.name
        if (item.linked_user) {
            name = name + " (" + item.linked_user.name + ")";
        }
        return name;
    },

    onSelectMember(item) {
      if (!item) {
        this.memberForm.team_member_id = null;
        this.memberForm.team_member_name = null;
        this.memberForm.designation = null;
        return;
      }
      this.memberForm.team_member_id = item.id;
      this.memberForm.team_member_name = this.formatMemberLabel(item);
      this.memberForm.designation = item.designation;
    },

  },

  setup() {
    const { fetchParties } = handleProjects();

    return {
      fetchParties
    }
  }
}
</script>
